
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { AssestManagementComponent } from '../../assest-management/assest-management.component';

import * as saveAs from 'file-saver';
import { environment } from 'src/environments/environment';
import { AddProgramComponent } from '../training-calendor/add-program/add-program.component';
@Component({
  selector: 'app-l-n-d',
  templateUrl: './l-n-d.component.html',
  styleUrls: ['./l-n-d.component.scss'],
})
export class LNDComponent  implements OnInit {

  selectedTypeTabIndex: number = 0;
  selectedTypeTabName = 'dashboard'
  buttonColorName: any;
  showSetupPopup: boolean = false;
  selectedTrainingTabIndex: number = 0; 
  programs = [];


  constructor(
    public router: Router,private dialog: MatDialog, private config: Config,
    private activatedroute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
  }

  tabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabName = event.tab.textLabel.toLowerCase().replace(/\s/g, '');
    this.selectedTypeTabIndex = event?.index;
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/lnd-setup', { operation: operation }]);

  }

  onClickback() {
    this.router.navigate(['/home/hrportal/lnd']);

  }

   
  
 
}
